import clsx from 'clsx';
import { Close } from '@material-ui/icons';
import Draggable from 'react-draggable';
import { IconButton } from '../../components/IconButton';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { useSort } from '../../hooks/useSort';

interface Props {
  open: boolean;
  onClose(): void;
}

export const MobileAppKeyButtons = ({ open, onClose }: Props) => {
  const { remote, remoteLoading, sendCommand } = useCitrusView();
  const { sortAsc } = useSort<{ order: number }>('order');
  const buttons = (remote?.buttons ?? [])
    .filter((button) => button.category === 'APPKEYS')
    .sort(sortAsc);
  const classes = useStyles();

  if (open === false) return null;

  return (
    <Draggable defaultClassName="z-[9999] shadow-2xl" bounds="parent">
      <div className="absolute bottom-8 left-[70px] p-4 gap-2 rounded grid grid-cols-3 bg-black/70">
        <div className="inline-flex items-center justify-between col-span-full py-2">
          <IconButton
            className="absolute top-0 right-0 pointer-events-auto"
            onClick={onClose}
            onTouchEnd={onClose}
          >
            <Close />
          </IconButton>
        </div>
        {(buttons ?? []).map((button) => (
          <button
            style={{ background: button.color }}
            className={clsx(classes.button, {
              '!text-xs':
                button.name.toLowerCase() === 'delete' ||
                button.name.toLowerCase() === 'enter',
            })}
            onClick={() => sendCommand(button.id)}
            onTouchEnd={() => sendCommand(button.id)}
          >
            {button.name}
          </button>
        ))}
      </div>
    </Draggable>
  );
};

const useStyles = () => ({
  button:
    'pointer-events-auto rounded-full border border-border-white h-8 w-16 text-2xl flex items-center justify-center focus:bg-white/20 active:bg-white/20 disabled:opacity-20',
});
